export const theme = "Sample";

export const colors = {
    primary: "#1d4ed8",
    secondary: "#5856D6",
    success: "#34C759",
    warning: "#FF9500",
    error: "#FF3B30",
    background: "#FFFFFF",
    backgroundDark: "#1F2937",
    gray: "#4B5563",
    white: "#FFFFFF",
    slate: "#334155",
    selectedBlue: "#1d4ed8",
    lightGray: "#E5E7EB",
    darkGray: "#374151",
    black: "#000000",
};
